import { render } from "./GestaoCrediario.vue?vue&type=template&id=4d059729&scoped=true"
import script from "./GestaoCrediario.vue?vue&type=script&lang=js"
export * from "./GestaoCrediario.vue?vue&type=script&lang=js"

import "./GestaoCrediario.vue?vue&type=style&index=0&id=4d059729&scoped=true&lang=css"

import exportComponent from "/home/devnote/Documentos/Features/Home Creditall/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d059729"]])

export default __exports__